import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Divider, Button, Row, Col } from '_zari/core'

import { IdGen, RounderUtil } from 'utils'

import * as Modals from './modals'
import * as Sections from './sections'

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      return [
        ...state,
        {
          ...action.payload,
          _idFila: IdGen.newId()
        }
      ]
    }
    case 'fill': {
      return action.payload
    }
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const MovimientosPresupuestoModal = ({ show, handleClose, mainFormData, submitFunction }) => {
  const __zariContext = React.useContext(ZariContext)

  const [movimientos, movimientosDispatcher] = React.useReducer(commonReducer, [])

  const [mostrarOrdenesCompraModal, setMostrarOrdenesCompraModal] = React.useState(false)

  const importeCompraTotalSinIgv = React.useMemo(() => {
    return RounderUtil.round((mainFormData.importeTotal || 0) - (mainFormData.importeIgv || 0))
  }, [mainFormData])

  const importeSumaTotalPresupuestos = React.useMemo(() => {
    const total = movimientos.reduce((suma, current) => RounderUtil.round(suma + current.importe), 0)
    return total
  }, [movimientos])

  const clickProcesar = React.useCallback(() => {
    if (!movimientos || movimientos.length === 0) {
      __zariContext.snack('error', 'Ingresar movimientos')
      return
    }

    if (importeCompraTotalSinIgv !== importeSumaTotalPresupuestos) {
      __zariContext.snack('error', 'El monto de presupuesto no coincide con el monto de la compra/gasto.')
      return
    }

    submitFunction({
      ...mainFormData,
      movimientosPresupuesto: movimientos
    })
  }, [__zariContext, movimientos, submitFunction, mainFormData, importeCompraTotalSinIgv, importeSumaTotalPresupuestos])

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>ASIGNAR PRESUPUESTOS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12} className='text-right'>
              <Button outline onClick={() => setMostrarOrdenesCompraModal(true)}>
                Ver ordenes compra
              </Button>
            </Col>
          </Row>
          <Divider noMargin />
          <Sections.DetallesCabeceraSection dispatch={movimientosDispatcher} />
          <Divider noMargin />
          <Sections.DetallesTablaSection detalles={movimientos} dispatch={movimientosDispatcher} />
          <Divider noMargin />
          <Sections.DiferenciaMontosSection
            importeCompraTotalSinIgv={importeCompraTotalSinIgv}
            importeSumaTotalPresupuestos={importeSumaTotalPresupuestos}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button color='secondary' onClick={handleClose}>
            Cancelar
          </Button>
          <Button onClick={clickProcesar}>Procesar</Button>
        </Modal.Footer>
      </Modal>
      {mostrarOrdenesCompraModal && (
        <Modals.OrdenesCompraModal
          show={mostrarOrdenesCompraModal}
          handleClose={() => setMostrarOrdenesCompraModal(false)}
          idSocio={mainFormData._idSocio}
          dispatch={movimientosDispatcher}
        />
      )}
    </>
  )
}

export default React.memo(MovimientosPresupuestoModal)
